import { onError } from "apollo-link-error";
import { notifyError } from "../sentry";

export const errorLink = onError(({ operation, graphQLErrors, networkError, response }) => {
  const errorData: { [key: string]: any } = {};
  if (operation.query.loc) {
    errorData.query = operation.query.loc.source.body;
  }
  if (operation.variables) {
    errorData.variables = operation.variables;
  }
  const networkErrorMessage = networkError ? networkError.message : "";
  const graphQLErrorsMessage = graphQLErrors
    ? graphQLErrors.map(graphQLError => graphQLError.message).join(", ")
    : "";
  const message = `ApolloError: ${networkErrorMessage}, ${graphQLErrorsMessage}`;

  notifyError(new Error(message), {
    extras: {
      ApolloError: {
        ...errorData,
        graphQLErrors,
        networkError,
        response
      }
    }
  });
});
